import TenantsApiClient from "api/TenantsApiClient";
import { useQuery } from "react-query";

export function useListAvailableTenants() {
    return useQuery(["tenants", "available"], () =>
        TenantsApiClient.listAvailableTenants().then((r) => r.data),
    );
}
